import React from 'react';
import { IThemeSelectItem } from '@src/slide/domain/ui-model/element-modeles/Interface/theme-model.interface';
import Styles from './index.less';
import { IThemeColorManager } from '@src/slide/application/service/theme-color-manager/index.interface';
import Snackbar from '@tencent/dui/lib/components/Snackbar';
import i18n from '@i18next/i18n';
import { IUiDataService } from '@src/slide/domain/ui-model/service/ui-data-service.interface';
import { transaction } from '@src/slide/domain/slide-app';
import { tdw } from '@src/slide/infrastructure/module/dependent/report/offline-data-report/tdw-report';
import {
    TDWActionType,
    TDWModuleType,
    TDWOperationType,
} from '@src/slide/infrastructure/module/dependent/report/offline-data-report/constant';

export interface IThemeColorCardProps {
    themeItem: IThemeSelectItem;
    themeColorManager?: IThemeColorManager;
    uiDataService: IUiDataService;
}

/**
 * 主题色切换卡片
 */
export class ThemeColorCard extends React.PureComponent<IThemeColorCardProps, any> {
    private isSnackbarClose = true;
    private loadingBar;

    public constructor(props: IThemeColorCardProps) {
        super(props);
    }

    public render() {
        const { themeItem } = this.props;
        const { colorSchema } = themeItem;
        return <div
            onClick={this.handleClick}
            className={Styles['theme-color-card']}>
            <div className={Styles['theme-color-grid']} style={{ background: `#${colorSchema.dk2.color}` }} />
            <div className={Styles['theme-color-grid']} style={{ background: `#${colorSchema.lt2.color}` }} />
            <div className={Styles['theme-color-grid']} style={{ background: `#${colorSchema.accent1.color}` }} />
            <div className={Styles['theme-color-grid']} style={{ background: `#${colorSchema.accent2.color}` }} />
            <div className={Styles['theme-color-grid']} style={{ background: `#${colorSchema.accent3.color}` }} />
            <div className={Styles['theme-color-grid']} style={{ background: `#${colorSchema.accent4.color}` }} />
            <div className={Styles['theme-color-grid']} style={{ background: `#${colorSchema.accent5.color}` }} />
            <div className={Styles['theme-color-grid']} style={{ background: `#${colorSchema.accent6.color}` }} />
        </div>;
    }

    private handleClick = async () => {
        const { themeColorManager, uiDataService, themeItem } = this.props;
        this.handleSnackbar();
        await uiDataService?.forceConvertSlides(uiDataService.presentation.children);
        requestAnimationFrame(async () => {
            transaction(() => {
                themeColorManager?.convertCustomColorToTheme(false, { ignorePlaceholder: true });
                themeColorManager?.applyThemeColor(themeItem.id);
            });
            this.handleSnackbar();
        });
        tdw({
            opername: TDWOperationType.DOC_PPT,
            module: TDWModuleType.BEAUTIFY_TAB,
            action: TDWActionType.BEAUTIFY_SWITCH_COLOR,
            ver5: themeItem.title,
        });
    };

    private handleSnackbar = () => {
        if (!this.isSnackbarClose) {
            this.loadingBar.close();
            this.isSnackbarClose = true;
        } else {
            this.loadingBar = Snackbar.show({
                autoClose: false, // 若为true（默认），则不会返回引用
                type: 'loading',
                message: `${i18n.t('正在切换中')}...`,
            });
            this.isSnackbarClose = false;
        }
    };
}
